export function mainUrl() {
  return "https://" + window.location.hostname;
}

export const checkUniqueValues = (array, keys) => {
  return keys.every(
    (key) => new Set(array.map((item) => item[key])).size === 1
  );
};

export const countUniqueValues = (array, key) => {
  return new Set(array.map((item) => item[key])).size;
};

export const destroyModal = (id) => {
  $(id).remove();
};

export const getCulture = () => {
  return $('#lng').val();
};

export const isMobileView = () => window.innerWidth < 768;

export const isValidMapUrl = (mapUrl) => {
  const shouldBeHttps = /^https:\/\//;
  return shouldBeHttps.test(mapUrl);
};

export const enchanceTargetLink = (selector) => {
  setTimeout(() => {
    const links = document.querySelectorAll(selector);
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
    });
  }, 1000);
};

export const getReleaseBy = (releaseByDate) => {
  const date = new Date(releaseByDate);

  const options = { day: '2-digit', month: 'short' };
  const locale = $('#lng').val() === "el-GR" ? "el" : "en";

  const formatted = date.toLocaleDateString(locale, options);
  const cleaned = formatted.replace('.', '');

  return { releaseBy: cleaned };
};

export const renderBookingPanelLinks = () => {
  const events = document.querySelectorAll(
    ".booking-panel-wrap__events-container .events-container__item"
  );
  events.forEach((e) => {
    let eventId = $(e)
      .find('[id*=bookButtonsDiv] a[evid][evid!=""]')
      .attr("evid");
    let moreInfo = $(
      `<div class='moreInfo' data-eventid='${eventId}'>${playdetailsv2_resources.AdditionalInfo}</div>`
    );
    $(e).find("[id*=bookButtonsDiv]").prepend(moreInfo);
  });
};

export function eventGroupCode() {
    return document.getElementById("REventGroupCode").innerHTML;
}

export function nodeAliasPath() {
  return document.getElementById("NodeAliasPath").innerHTML;
}

export function eventGroupId() {
  return document.getElementById("EventGroupId").innerHTML;
}

export function artistNodeId() {
  return document.getElementById("ArtistNodeId").value;
}

export function urlSegment() {
  //takes segment after domain e.g tickets for .gr, evenements for .be etc
  const url = window.location.href;
  const array = url.split("/");
  return {
    segment: array[3],
    category: array[4],
  };
}

/**
 * For added read more - read less feature.
 * @param {any} id
 * @param {any} height
 */
export function addClamped(id, className, height) {
  let element = document.getElementById(id);

  if (!exists(element)) {
    return false;
  }

  if (height == undefined || height == null) {
    height = 0;
  }

  /*clamp if height is more than 450px*/
  if (element.clientHeight > height) {
    addClass(element, className);

    return true;
  }

  return false;
}

/**
 * Returns if element is defined.
 * @param {any} element
 */
export function exists(element) {
  return element != undefined && element != null;
}

/**
 * Returns if element is at the top of the screen, +- some extra room.
 * @param {any} elementId
 * @param {any} extraRoom
 */
export function isAtTheTop(elementId, extraRoom) {
  if (extraRoom == undefined || extraRoom == null) {
    extraRoom = 0;
  }

  let el = document.getElementById(elementId);

  if (exists(el)) {
    return el.offsetTop - window.scrollY <= extraRoom;
  } else {
    return false;
  }
}

/**
 * Returns if element is currently visible, +- some extra room.
 * @param {any} id
 * @param {any} extraHeight
 */
export function isInViewport(id, extraHeight) {
  if (extraHeight == undefined || extraHeight == null) {
    extraHeight = 0;
  }

  let element = document.getElementById(id);

  if (!exists(element)) {
    return false;
  }

  if (
    window.scrollY >= element.offsetTop - window.innerHeight + extraHeight &&
    window.scrollY <= element.offsetTop + element.offsetHeight + extraHeight
  ) {
    return true;
  } else {
    return false;
  }
}

/**
 * Adds class to element.
 * @param {any} element
 * @param {any} className
 */
export function addClass(element, className) {
  if (!exists(element)) {
    return false;
  }

  if (!element.classList.contains(className)) {
    element.classList.add(className);

    return true;
  }

  return false;
}

/**
 * Removes class from element.
 * @param {any} element
 * @param {any} className
 */
export function removeClass(element, className) {
  if (!exists(element)) {
    return false;
  }

  if (element.classList.contains(className)) {
    element.classList.remove(className);

    return true;
  }

  return false;
}

/**
 * Scrolls to given element.
 * @param {any} element
 */
export function smoothScroll(element) {
  if (exists(element)) {
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }
}

/**
 * Returns the events title for Event Page.
 * */
export function getEventTitle() {
  let titleElement = document.getElementById("r_maininfo");

  return exists(titleElement) ? titleElement.innerText : "";
}

export function getYoutubeThumbnail(data) {}

export function isMobileDevice() {
  return (
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
      navigator.userAgent
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      navigator.userAgent.substr(0, 4)
    )
  );
}

export function isAndroidDevice() {
  return /Android/i.test(navigator.userAgent);
}

export const hideIntercom = () => {
  if (window.Intercom) {
    Intercom("update", { hide_default_launcher: true });
  }
};

export const showIntercom = () => {
  if (window.Intercom) {
    Intercom("update", { hide_default_launcher: false });
  }
};

export const getBrowserScrollbarWidth = () => {
  return window.innerWidth - document.documentElement.clientWidth;
};

export const deactivateScrollbar = (scrollbarWidth) => {
  document.documentElement.style.overflow = "hidden";
  document.querySelector("body").style.marginRight = `${scrollbarWidth}px`;
};

export const reactivateScrollbar = () => {
  document.documentElement.style.overflow = "auto";
  document.querySelector("body").style.marginRight = `0`;
};

export const handleCopyTextOnClick = (text, action) => {
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text).then(() => !isAndroidDevice() && action());
  } else {
    //old browsers Fallback
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      if (!isAndroidDevice()) {
        action();
      }
    } catch (err) {
      console.error("Copy failed", err);
    }
    document.body.removeChild(textArea);
  }
};

export const scrollToNextGroup = (ref, back) => {
  let element = ref.current;
  let width = element.clientWidth;
  if (back) width *= -1;
  element.scrollBy({ left: width });
};

// TODO: Please revisit below logic!

export const scrollToElement = (headerVisible, id) => {
  let menu = document.getElementById("appbar");
  let heroBanner = document.getElementById("HeroBanner");
  let menuHeight = menu.clientHeight + 16;
  let el = document.getElementById(id);
  let pos = el.getBoundingClientRect().top + window.scrollY;
  let offset =
    id === "r_summaryText"
      ? headerVisible
        ? heroBanner
          ? menuHeight + 24
          : menuHeight + 1
        : heroBanner
        ? 16
        : 1
      : headerVisible
      ? 2 * menuHeight
      : menuHeight;
  window.scrollTo({ top: pos - offset, behavior: "smooth" });
};
